import styled from 'styled-components';
import React from 'react';
import { FlexContainer } from '@/styles/Containers';
import searchIcon from '../../assets/icons/search.svg';
import DropDownCourses from './DropDownCourses';
import { CalculatorCourse } from './SemesterCalculator';

interface InputOvalProps {
  inputValue: boolean;
}

const InputOval = styled.input<InputOvalProps>`
  position: relative;
  z-index: 1;
  height: 2rem;
  width: 18rem;
  outline: none;
  padding-left: 0.5rem;
  font-family: poppinsregular;
  border-radius: 5rem;
  color: ${({ theme }) => theme.color.black};
  border: 0.5px solid ${({ theme }) => theme.color.black};
  margin: 1rem 0 2.5rem 0;
  background-color: ${({ theme }) => theme.color.white};
  text-align: left;
  &::placeholder {
    font-family: 'poppinslight';
    padding-left: 0.5px;
  }
  &:not(:placeholder-shown) {
    border-top-left-radius: 5rem;
    border-top-right-radius: 5rem;
  }
  ${({ inputValue }) =>
    inputValue &&
    ` padding-left: 1.4rem;
      border-top-left-radius: 1.5rem;
      border-top-right-radius: 1.5rem;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}

  &::-webkit-search-cancel-button {
    display: none;
    -webkit-appearance: none;
  }
`;

const IconButton = styled.button`
  position: sticky;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  margin-top: 1.35rem;
  margin-left: -2rem;
  z-index: 3;
  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
  img {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

interface InputProps {
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  inputValue: string;
  addCourseToSemester: (course: CalculatorCourse) => void;
}
const InputSearchOval = ({ setInputValue, inputValue, addCourseToSemester }: InputProps) => {
  const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    setInputValue(e.currentTarget.value.toUpperCase());
  };

  return (
    <FlexContainer flexDirection='column' margin='0 0 0 0.5rem'>
      <FlexContainer>
        <InputOval
          type='search'
          onChange={handleInputChange}
          placeholder='Søk etter emnekode eller navn..'
          maxLength={7}
          inputValue={inputValue.length > 0}
        ></InputOval>
        <IconButton>
          <img src={searchIcon} alt='search icon' />
        </IconButton>
      </FlexContainer>
      {inputValue.length > 0 && <DropDownCourses inputValue={inputValue} addCourseToSemester={addCourseToSemester}></DropDownCourses>}
    </FlexContainer>
  );
};

export default React.memo(InputSearchOval);
